<div class="document-management-page">
  <div class="document-management-page__content">
    <tf-folder-browser
      [initialFolderId]="initialFolderId()"
      [initialDocumentId]="initialDocumentId()"
      [initialView]="initialView()"
      (currentFolderIdChange)="onCurrentFolderIdChange($event)"
      (currentDocumentIdChange)="onCurrentDocumentIdChange($event)"
      (currentViewChange)="onCurrentViewChange($event)" />
  </div>
</div>
